import React from 'react';
import { Grid, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import FAQHeader from './FAQHeader';
function CommonFAQ(props) {
  const { heading, faq, isMobile } = props;

  return (
    <Grid container
      direction='column'>
      { isMobile ?
        '' : <Grid>
          <FAQHeader />
        </Grid>}
      <Grid item container
        direction='column'>
        { isMobile ? '' :
          <Grid item className='mb40mi48'>
            <span className="arrowIcon">
              <ArrowBackIosIcon /></span>
            <span className='heading'>{heading}</span>
          </Grid>}
        {heading === "About ITER Services" ?
          <Grid item
            alignItems='center'
            justifyContent='center'
            className={'mi48mb50 font18'}
          >
            {faq?.map((ele, idx) => (
              <Grid container key={idx} className='mt15 bgFaq'>
                <Grid item md={12}>
                  <Typography className='font18 fontMedium'><span>{idx + 1}.
                  </span>{ele.question}</Typography>
                  <Typography className='font18 mt3'><span className='faqHyperlink' dangerouslySetInnerHTML={{__html:ele.answer}}></span></Typography>
                </Grid>
              </Grid>

            ))}
          </Grid> :
          <Grid item
            alignItems='center'
            justifyContent='center'
            className={'mi48mb50 font18'}
          >
            {faq?.map((ele, idx) => (
              <Grid container key={idx} className='mt15 bgFaq'>
                <Grid item md={11.5}>
                  <Typography className='font18 fontMedium'><span>{idx + 1}.
                  </span>{ele.question}</Typography>
                  <Typography className='font18 mt3'><span className='faqHyperlink' dangerouslySetInnerHTML={{__html:ele.answer}}></span></Typography>
                </Grid>
           </Grid>
            ))}
          </Grid>
        }
      </Grid>
    </Grid>
  )
}
export default CommonFAQ